import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

// Identifier'ın email mi telefon mu olduğunu tespit eder
const buildLoginFilter = (identifier, password) => {
  const trimmed = (identifier || "").trim();
  const isEmail = /\S+@\S+\.\S+/.test(trimmed);
  if (isEmail) {
    return `Users_Email eq '${trimmed}' and Users_Password eq '${password}'`;
  }
  // Telefon: sadece rakamları al, başındaki 90 ülke kodunu çıkar (DB'de 10 haneli saklanıyor)
  let digits = trimmed.replace(/\D/g, "");
  if (digits.startsWith("90") && digits.length > 10) digits = digits.slice(2);
  if (digits.startsWith("0") && digits.length > 10) digits = digits.slice(1);
  return `Users_PhoneNumber eq '${digits}' and Users_Password eq '${password}'`;
};

// OData API Giriş İstek Fonksiyonu
const loginApi = async (identifier, password) => {
  // NOT: OData $filter ile GET isteği atarak kullanıcı doğruluyoruz.
  const filter = buildLoginFilter(identifier, password);
  const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Users?$filter=${encodeURIComponent(filter)}`);
  if (!response.ok) {
    throw new Error("Sunucuya ulaşılamadı.");
  }
  return await response.json();
};

// authSaga.js içindeki loginUser jeneratör fonksiyonu
function* loginUser({ payload: { user, history } }) {
  try {
    const identifier = user.identifier || user.email;
    const data = yield call(loginApi, identifier, user.password);

    if (data && data.value && data.value.length > 0) {
      const loggedInUser = data.value[0]; 
      
      // Kullanıcı bilgisini ve tipini kaydediyoruz
      // Örn: loggedInUser.Users_Type_ID === 1 ise Admin
      localStorage.setItem("authUser", JSON.stringify(loggedInUser));
      
      yield put(loginSuccess(loggedInUser));
      
      // Başarılı girişte yönlendirme
      history('/dashboard'); 
    } else {
      yield put(apiError("Geçersiz e-posta/telefon veya şifre girdiniz."));
    }
  } catch (error) {
    yield put(apiError(error.message || "Giriş hatası."));
  }
}
function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess());
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

// Social Login şimdilik devre dışı bırakılabilir veya kendi backendinize uyarlanabilir
function* socialLogin({ payload: { type, history } }) {
  try {
    yield put(apiError("Sosyal giriş şu anda desteklenmemektedir."));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;